export default __webpack_public_path__ + "static/3-1-frontend-75b09d4d39b6bab435c810770159ec5d.gif";